import { Typography } from '@ag1/ui';
import { CustomPortableText } from 'shared/studio/PortableText';
import { routes } from '@portal/constants/routes';
import { EduCategoryNavigation } from '../EduCategoryNavigation';
import { EduHubCategoriesHeaderProps, TagLink } from '../../types';
import styles from './EduCategoryHeader.module.scss';

export const EduCategoryHeader = ({
  title,
  subtitle,
  categories = [],
  activeCategory,
  titleForAllArticles
}: EduHubCategoriesHeaderProps) => {
  const { eduHub, eduHubCategory } = routes;

  const getCategoryLinks = (): TagLink[] => {
    const linksData = categories
      ?.filter((category) => !category.isEmpty)
      .map((category) => ({
        title: category.title || '',
        path: eduHubCategory({ slug: category?.slug?.current || '' }),
        // eslint-disable-next-line no-underscore-dangle
        id: category._id
      }));

    linksData.unshift({
      title: titleForAllArticles,
      path: eduHub,
      id: ''
    });
    return linksData;
  };

  return (
    <header>
      <div className={styles.header}>
        <Typography variant="headline" size="1" noPadding color="black-new">
          <CustomPortableText value={title} tag="h2" />
        </Typography>
        {subtitle && (
          <Typography
            variant="subtitle"
            size="2"
            component="div"
            noPadding
            color="black-new"
            className={styles.subtitle}>
            <CustomPortableText value={subtitle} />
          </Typography>
        )}
      </div>
      <EduCategoryNavigation links={getCategoryLinks()} activeCategory={activeCategory} />
    </header>
  );
};
